import router from "@/core/routes/web";
import store from "@/core/store";
import {RESET_LAYOUT_CONFIG} from "@/core/store/modules/layout/constants";


function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({...context, next: nextMiddleware});
    };
}

router.beforeEach((to, from, next) => {
      let link =  document.querySelector("link[rel='canonical']")  ;
      link.setAttribute('href', location.protocol+ '//' + window.location.host+to.path );

    document.title = to.meta.title
    if(to.meta.description){
        let description =  document.querySelector("meta[name='description']")  ;
        let ogDescription =  document.querySelector("meta[property='og:description']")  ;
        description.setAttribute('content', to.meta.description)
        ogDescription.setAttribute('content', to.meta.description)
    }
     store.dispatch(RESET_LAYOUT_CONFIG);

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();

});

export default router